import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'
import 'firebase/storage'
import 'firebase/functions'
import router from './router/'
import { store } from './store/index.js'
import './registerServiceWorker'
import AlertCmp from './components/Shared/Alert.vue'
import VueAnalytics from 'vue-analytics'
import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'

Sentry.init({
  dsn: 'https://5abc198f33fd4c9d85418808e66ca0ee@sentry.io/1767922',
  integrations: [new Integrations.Vue({ Vue, attachProps: true, logErrors: true })]
})

Vue.config.productionTip = false

Vue.component('app-alert', AlertCmp)

Vue.use(VueAnalytics, {
  id: 'UA-147738058-1',
  router,
  trackEvent: true
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App),
  created () {
    firebase.initializeApp({
      apiKey: process.env.VUE_APP_APIKEY,
      authDomain: process.env.VUE_APP_AUTHDOMAIN,
      databaseURL: process.env.VUE_APP_DATABASEURL,
      projectId: process.env.VUE_APP_PROJECTID,
      storageBucket: process.env.VUE_APP_STORAGEBUCKET,
      messagingSenderId: process.env.VUE_APP_MESSAGINGSENDERID,
      appId: process.env.VUE_APP_APPID
    })
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        this.$store.dispatch('autoSignIn', user)
      }
    })
  }
})
